<template>
  <CustomerNew />
</template>

<script setup lang="ts">
import CustomerNew from "./Create/CustomerNew.vue";
</script>

<style scoped></style>
